import {
  CardWithAreaLine,
  CollapsibleCard
} from '@yes.technology/react-toolkit'
import styled from 'styled-components'
import { FilterButton } from '../../FilterFields.styles'

export const StyledCardWithAreaLine = styled(CardWithAreaLine)<{
  backgroundColor?: string
  color?: string
  disabled?: boolean
}>``

export const StyledCollapsibleCard = styled(CollapsibleCard)`
  & > :first-child {
    nav {
      padding: 4px 16px;

      @media (max-width: 768px) {
        height: 100%;
        padding: 12px 16px;
      }
    }
  }
`

export const StyledFilterButton = styled(FilterButton)<{
  color?: string
}>`
  @media (min-width: 768px) {
    margin-right: 24px;
    margin-left: 8px;
  }

  @media (min-width: 992px) {
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    width: calc(100% - 8px) !important;
  }

  & > :first-child {
    ${({ theme, color }) => `
      color: ${color || theme.colors.primary};
      border-color: ${color || theme.colors.primary};
    `};
    background-color: transparent;
  }
`

export const FirstElement = styled.div<{ color?: string }>`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  color: ${({ color }) => color || '#303032'};
  width: max-content;
`

export const CenterWrapper = styled.div`
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const GroupSideButtons = styled.div`
  display: grid;
  grid-template: 40px / minmax(152px, 1fr) repeat(auto-fit, 40px);
  gap: 1rem;
  width: calc(100% + 28px);

  @media (min-width: 768px) {
    margin-right: 24px;
    margin-left: 8px;
    width: auto;
  }
`
